import React, { useState } from 'react';
import { Container, TabContent, TabPane } from 'reactstrap';

import t, { partial } from '../../util/translation/translation';
import NavTab from '../../shared/components/custom/NavTab';
import TransactionsList from './components/TransactionsList';
import TransactionsAnalytics from './components/TransactionsAnalytics';
import CommunicationTransactionsList from './components/CommunicationTransactionsList';

const AllTransactionsListPage = () => {
  const [tab, setTab] = useState(1);
  const p = partial('transactions');

  return (
    <Container>
      <NavTab
        activeTab={tab}
        tabs={[
          t('shared.Statistics'),
          p('transactions'),
          t('shared.communication'),
        ]}
        setTab={setTab}
      />
      <TabContent activeTab={tab}>
        <TabPane tabId="1">
          <TransactionsAnalytics />
        </TabPane>
        <TabPane tabId="2">
          <TransactionsList />
        </TabPane>
        <TabPane tabId="3">
          <CommunicationTransactionsList />
        </TabPane>
      </TabContent>
    </Container>
  );
};

export default AllTransactionsListPage;
